export { default as Img200 } from './processed/200/Exodus-Gods-&-Kings.jpg';
export { default as Img400 } from './processed/400/Exodus-Gods-&-Kings.jpg';
export { default as Imgthumb } from './processed/thumb/Exodus-Gods-&-Kings.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Exodus-Gods-&-Kings.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Exodus-Gods-&-Kings.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      180,
      92,
      78
    ],
    "_population": 3,
    "_hsl": [
      0.02287581699346404,
      0.4047619047619049,
      0.5058823529411764
    ]
  },
  "LightVibrant": {
    "_rgb": [
      177,
      203,
      237
    ],
    "_population": 1500,
    "_hsl": [
      0.5944444444444444,
      0.6250000000000001,
      0.8117647058823529
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      92,
      46,
      26
    ],
    "_population": 22,
    "_hsl": [
      0.050505050505050504,
      0.559322033898305,
      0.23137254901960785
    ]
  },
  "Muted": {
    "_rgb": [
      145,
      124,
      101
    ],
    "_population": 2681,
    "_hsl": [
      0.08712121212121214,
      0.17886178861788618,
      0.48235294117647054
    ]
  },
  "LightMuted": {
    "_rgb": [
      190,
      175,
      154
    ],
    "_population": 1778,
    "_hsl": [
      0.09722222222222222,
      0.21686746987951816,
      0.6745098039215687
    ]
  },
  "DarkMuted": {
    "_rgb": [
      101,
      82,
      70
    ],
    "_population": 3065,
    "_hsl": [
      0.06451612903225809,
      0.18128654970760225,
      0.33529411764705885
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Exodus-Gods-&-Kings.js